// extracted by mini-css-extract-plugin
export var nav = "Header-module--nav--YOsqx";
export var active = "Header-module--active--33mqH";
export var name = "Header-module--name--2Fdi6";
export var darkMode = "Header-module--dark-mode--2su6Z";
export var lightMode = "Header-module--light-mode--2Lket";